/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from "@tanstack/react-query";
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import * as axios from "axios";
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from "axios";
import type { HTTPValidationError, AccountInsights } from "./client.schemas";

/**
 * @summary Get Insights
 */
export const insightsGetInsights = (
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<AccountInsights>> => {
  return axios.default.get(`/insights/`, options);
};

export const getInsightsGetInsightsQueryKey = () => {
  return [`/insights/`] as const;
};

export const getInsightsGetInsightsQueryOptions = <
  TData = Awaited<ReturnType<typeof insightsGetInsights>>,
  TError = AxiosError<void | HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof insightsGetInsights>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getInsightsGetInsightsQueryKey();

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof insightsGetInsights>>
  > = ({ signal }) => insightsGetInsights({ signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof insightsGetInsights>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type InsightsGetInsightsQueryResult = NonNullable<
  Awaited<ReturnType<typeof insightsGetInsights>>
>;
export type InsightsGetInsightsQueryError =
  AxiosError<void | HTTPValidationError>;

/**
 * @summary Get Insights
 */
export const useInsightsGetInsights = <
  TData = Awaited<ReturnType<typeof insightsGetInsights>>,
  TError = AxiosError<void | HTTPValidationError>,
>(options?: {
  query?: Partial<
    UseQueryOptions<
      Awaited<ReturnType<typeof insightsGetInsights>>,
      TError,
      TData
    >
  >;
  axios?: AxiosRequestConfig;
}): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getInsightsGetInsightsQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: QueryKey;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
};
